import React from 'react';
import PropTypes from 'prop-types';
import AppSelect from '../../../../../../common/AppSelect';
import AppInput from '../../../../../../common/AppInput';
import Message from '../../../../../../common/Message';
import {
  BANK_OPTIONS,
  OPTIONS,
  cancelPurchaseMapper,
} from '../../../../../../../helpers/tickets/CancelPurchaseHelper';
import { useCancelPurchaseFormStyles } from './styles';

const CancelPurchaseFormDebit = ({ ...props }) => {
  const { stateData, onData, onPayment } = props;
  const classes = useCancelPurchaseFormStyles();

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });
  };

  const handleChangePaymentMethod = (e) => {
    onPayment(e.target);
  };

  return (
    <React.Fragment>
      <AppSelect
        label="Medio de pago"
        name="paymentMethod"
        options={OPTIONS}
        onChange={handleChangePaymentMethod}
        required
        value={'Tarjeta de débito'}
        success={stateData?.paymentMethod?.success || false}
        error={stateData?.paymentMethod?.error || false}
        onClick={() => {}}
        onBlur={() => {}}
      />
      <AppSelect
        options={BANK_OPTIONS}
        label="Banco"
        name="bankOption"
        required
        onChange={handleChange}
        onClick={() => {}}
        onBlur={() => {}}
        success={stateData?.bankOption?.success || false}
        error={stateData?.bankOption?.error || false}
        errorMessage={stateData?.bankOption?.message}
      />
      <AppInput
        required
        name="accountNumber"
        label="Nº de cuenta"
        onChange={handleChange}
        onClick={() => {}}
        onBlur={() => {}}
        success={stateData?.accountNumber?.success || false}
        error={stateData?.accountNumber?.error || false}
        errorMessage={stateData?.accountNumber?.message}
      />
      <AppInput
        required
        name="accountAddress"
        label="Dirección"
        onChange={handleChange}
        onClick={() => {}}
        onBlur={() => {}}
        success={stateData?.accountAddress?.success || false}
        error={stateData?.accountAddress?.error || false}
        errorMessage={stateData?.accountAddress?.message}
      />
      <div className={classes.message}>
        <Message
          message={cancelPurchaseMapper.get('Tarjeta de débito')}
          fullRounded
          severity={'info'}
        />
      </div>
    </React.Fragment>
  );
};

CancelPurchaseFormDebit.propTypes = {
  stateData: PropTypes.object,
  onData: PropTypes.func,
  onPayment: PropTypes.func,
};

export default CancelPurchaseFormDebit;
